<script setup lang="ts">
const route = useRoute();

useHead({
  title: route.meta.title || "SWICA Health",
  meta: [
    {
      name: "description",
      content: (route.meta.description as string) || "SWICA Health",
    },
  ],
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
